import React from "react";
import { Card } from "reactstrap";

const CardAlamat = ({ data, setIsOpen, setFormAddress, selected, onSelectAlamat }) => {
  return (
    <Card
      className={`mb-3 shadow-sm `}
      style={{ cursor: "pointer", borderWidth: "2px", borderColor: data?.public_id === selected?.public_id ? "#749BC2" : "" }}
    >
      <div className="d-block d-sm-flex justify-content-between align-items-center border-bottom px-3 py-2">
        <div className="d-flex align-items-center mb-2 mb-sm-0" style={{ gap: "3px" }}>
          <span className="badge px-3 py-1 text-white" style={{ backgroundColor: "#5EABD6" }}>{data.label}</span>
          <span className="badge px-3 py-1 text-white" style={{ backgroundColor: "#91C8E4" }}>
            {data.is_default ? "Default" : ""}
          </span>
        </div>
        <div className="d-flex flex-wrap justify-content-sm-end" style={{ gap: "2px" }}>
          <button
            type="button"
            className="btn btn-sm text-white"
            style={{ backgroundColor: "#34699A" }}
            onClick={() => onSelectAlamat(data)}
          >
            Pilih Alamat
          </button>
          <button
            type="button"
            className="btn btn-sm text-white"
            style={{ backgroundColor: "#58A0C8" }}
            onClick={() => {
              setFormAddress(data);
              setIsOpen(true);
            }}
          >
            Ubah Alamat
          </button>
        </div>
      </div>


      <div className="px-3 py-1 row text-sm text-muted">
        <div className="col-md-3 ">
          <div className="fw-bold">Nama Penerima</div>
          {data.nama}
        </div>
        <div className="col-md-3 ">
          <div className="fw-bold">Nomor Telepon</div>
          {data.phone}
        </div>
        <div className="col-md-3 ">
          <div className="fw-bold">Kota</div>
          {data.kota}
        </div>
      </div>
      <hr />
      <div className="px-3 pb-3">
        <div className="fw-bold " style={{ fontWeight: "bold" }}>Alamat Lengkap</div>
        <div className="text-muted">
          {`${data.alamat}, Kec. ${data.kecamatan}, Kab/Kota. ${data.kota}, Prov. ${data.provinsi}, Kode Pos ${data.kode_pos}`}
        </div>
      </div>
    </Card>

  );
};

export default CardAlamat;
